import { setOriginalWorkflowVariables } from "../../../../actions/taskSidebar";
import { notifyIcon, requestMethod } from "../../../../config";
import envConfig from "../../../../env.config";
import { getProjectVariables } from "../../../../shared/services/projectVariables.service";
import { fetch } from "../../../../shared/services/api.service";
import { appendProjectVariablesToWorkflowList } from "../../../../shared/utils/projectVariablesChipMerge.utils";
import store from "../../../../store";
import { checkApiSuccess } from "../../../../utils";
import { getNotification } from "../../../../utils/common";

const WORKFLOW_URL = `${envConfig.BASE_URL.BASE_API_URL}/workflow`;

export const addWorkflowVariables = async (data) => {
  let requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/addWorkflowVariables`,
    data: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const getWorkflowVariables = async (params) => {
  const { projectId, mergeProjectChips, ...apiParams } = params || {};
  const shouldMergeProjectChips =
    projectId && (mergeProjectChips === true || Boolean(apiParams?.formId));
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowVariables`,
    params: apiParams,
  };
  let response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    if (response.data.data) {
      let list = response.data.data;
      if (shouldMergeProjectChips) {
        const projectDocs = await getProjectVariables(projectId, apiParams.formId);
        return [...(list || []), ...(projectDocs.map((doc) => ({ ...doc, isProjectVariable: true })) || [])];
      } else {
        return list;
      }
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const updateWorkflowVariables = async (data) => {
  let requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/updateWorkflowVariables`,
    data: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data.data;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const deleteWorkflowVariable = async (data) => {
  let requestConfig = {
    method: requestMethod.DELETE,
    url: `${WORKFLOW_URL}/deleteWorkflowVariable`,
    data: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const getUniqueVariableName = async (params) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getUniqueVariableName`,
    params: params,
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data.data;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const checkIsVariableNameUnique = async (params) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/checkIsVariableNameUnique`,
    params: params,
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data.data?.exists;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const addOrUpdateWorkflowExpression = async (data) => {
  let requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/addOrUpdateWorkflowExpression`,
    data: data,
  };

  let response = await fetch(requestConfig, true, true);

  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data;
    } else {
      getNotification(response.data.message, notifyIcon.ERROR_ICON);
      return null;
    }
  } else {
    return null;
  }
};

export const getWorkflowExpressionByVariableId = async (params) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowExpressionByVariableId`,
    params: params,
  };

  let response = await fetch(requestConfig, true, false);

  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data.data;
    }
  } else {
    return null;
  }
};

/**
 * Updates form-specific chip properties
 * @param {Object} data - The payload containing workflowVariableId, formId, and the property being changed
 * @param {string} data.workflowVariableId - The ID of the workflow variable
 * @param {string} data.formId - The ID of the form
 */
export const updateFormChips = async (data) => {
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/updateWorkflowFormVariables`,
    data: data,
  };

  let response = await fetch(requestConfig, true, true);

  if (checkApiSuccess(response)) {
    if (response.data.data) {
      return response.data.data;
    } else {
      getNotification(response.data.message, notifyIcon.ERROR_ICON);
      return null;
    }
  } else {
    return null;
  }
};

/**
 * Fetches dimensions/options bundle from the server.
 */
export const getDimensionAndOptions = async (params) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getDimensionAndOptions`,
    params,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    const d = response.data?.data;
    return {
      dimensions: Array.isArray(d.dimensions) ? d.dimensions : [],
      options: Array.isArray(d.options) ? d.options : [],
    };
  }
  return null;
};

export const addWorkflowVariableDimension = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/addWorkflowVariableDimension`,
    data,
  };
const response = await fetch(requestConfig, true, true);
if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  else  {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
    return null;
  }

};

/**
 * Updates an existing multi-dimension column.
 * @param {Object} data
 * @param {string} data.workflowVariableId
 * @param {number|string} data.workflowId
 * @param {{ id: number|string, label: string, type: string }} data.dimension
 */
export const updateWorkflowVariableDimension = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/updateWorkflowVariableDimension`,
    data,
  };
 const response = await fetch(requestConfig, true, true);
 if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  else  {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
    return null;
  }
};

/**
 * Deletes a multi-dimension column.
 * @param {Object} data
 * @param {string} data.workflowVariableId
 * @param {number|string} data.workflowId
 * @param {number|string} data.id - Dimension id
 */
export const deleteWorkflowVariableDimension = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${WORKFLOW_URL}/deleteWorkflowVariableDimension`,
    data,
  };
const response = await fetch(requestConfig, true, true);
if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  else  {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
    return null;
  }
};

export const addWorkflowVariableOption = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/addWorkflowVariableOption`,
    data,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};

export const updateWorkflowVariableOption = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/updateWorkflowVariableOption`,
    data,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};

export const deleteWorkflowVariableOption = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${WORKFLOW_URL}/deleteWorkflowVariableOption`,
    data,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};

export const deleteAllOptions = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${WORKFLOW_URL}/deleteAllOptions`,
    data,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};
